import CloseIcon from "@mui/icons-material/Close";
import { useContext, useEffect, useState } from "react";
import * as S from "./modal.styles";
import Modal from ".";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import urls from "../../utils";
import { toast } from "react-toastify";
import { p2e } from "../../common/price";
import { ResultContextDispatcher } from "../context/ResultProvider";
import { useNavigate } from "react-router-dom";
const VerifyModal = ({
  open,
  onClose,
  title,
  mobile,
  setVerifySeccess,
  verifySeccess,
}) => {
  const [openModal, setOpenModal] = useState(open);
  const setResult = useContext(ResultContextDispatcher);
  const navigate = useNavigate();
  useEffect(() => {
    setOpenModal(open);
  }, [open]);

  const resultHAndler = () => {
    const data = {
      fullname: JSON.parse(localStorage.getItem("infoPerson"))[0]
        ? JSON.parse(localStorage.getItem("infoPerson"))[0].fullname
        : "",
      city: JSON.parse(localStorage.getItem("infoPerson"))[0]
        ? JSON.parse(localStorage.getItem("infoPerson"))[0].city
        : "",
      degree: JSON.parse(localStorage.getItem("infoPerson"))[0]
        ? JSON.parse(localStorage.getItem("infoPerson"))[0].degree
        : "",

      race: JSON.parse(localStorage.getItem("infoPerson"))[0]
        ? JSON.parse(localStorage.getItem("infoPerson"))[0].race
        : "",
      age: JSON.parse(localStorage.getItem("infoPerson"))[1]
        ? JSON.parse(localStorage.getItem("infoPerson"))[1].age
        : "",
      bellySize: JSON.parse(localStorage.getItem("infoPerson"))[1]
        ? JSON.parse(localStorage.getItem("infoPerson"))[1].bellySize
        : "",
      gender: JSON.parse(localStorage.getItem("infoPerson"))[1]
        ? JSON.parse(localStorage.getItem("infoPerson"))[1].gender
        : "",
      weight: JSON.parse(localStorage.getItem("infoPerson"))[1]
        ? JSON.parse(localStorage.getItem("infoPerson"))[1].Weight
        : "",
      height: JSON.parse(localStorage.getItem("infoPerson"))[1]
        ? JSON.parse(localStorage.getItem("infoPerson"))[1].height
        : "",
      smoker: JSON.parse(localStorage.getItem("infoPerson"))[2]
        ? JSON.parse(localStorage.getItem("infoPerson"))[2].smoker
        : "",
      cigarettesCount: JSON.parse(localStorage.getItem("infoPerson"))[2]
        ? JSON.parse(localStorage.getItem("infoPerson"))[2].cigarettesCount
        : "",
      bps:
        JSON.parse(localStorage.getItem("infoPerson"))[3] &&
        JSON.parse(localStorage.getItem("infoPerson"))[3].bps
          ? JSON.parse(localStorage.getItem("infoPerson"))[3].bps
          : "",
      cholesterol: JSON.parse(localStorage.getItem("infoPerson"))[6]
        ? JSON.parse(localStorage.getItem("infoPerson"))[6].cholesterol
        : "",
      hasPressure: JSON.parse(localStorage.getItem("infoPerson"))[4]
        ? JSON.parse(localStorage.getItem("infoPerson"))[4].hasPressure
        : "",
      pressureDruge: JSON.parse(localStorage.getItem("infoPerson"))[4]
        ? JSON.parse(localStorage.getItem("infoPerson"))[4].pressureDruge
        : "",
      hasDiabetes: JSON.parse(localStorage.getItem("infoPerson"))[5]
        ? JSON.parse(localStorage.getItem("infoPerson"))[5].hasDiabetes
        : "",
      diabetesDrug: JSON.parse(localStorage.getItem("infoPerson"))[5]
        ? JSON.parse(localStorage.getItem("infoPerson"))[5].diabetesDrug
        : "",
      type: JSON.parse(localStorage.getItem("infoPerson"))[6]
        ? JSON.parse(localStorage.getItem("infoPerson"))[6].type
        : "",
    };
    const lastData = {
      ...data,
      hasDiabetes: data.hasDiabetes === "true" ? true : false,
      diabetesDrug: data.diabetesDrug === "true" ? true : false,
      pressureDruge: data.pressureDruge === "true" ? true : false,
      smoker: data.smoker === "true" ? true : false,
      otp: JSON.parse(localStorage.getItem("otp"))
        ? p2e(JSON.parse(localStorage.getItem("otp")))
        : "",
      mobile: p2e(mobile),
    };
    axios.post(urls.calculator, lastData).then((res) => {
      console.log(res.data);
      localStorage.clear();
      navigate(`/result/${res.data.request.uid}`);
      setResult(res.data);
      console.log(res.data);
      localStorage.setItem("result", JSON.stringify(res.data), 60 * 60 * 1000);
    });
  };
  const initialValues = {
    otp: "",
  };
  const onSubmit = (values) => {
    const data = {
      mobile: mobile,
      otp: p2e(values.otp),
    };

    axios
      .post(urls.verify, data)
      .then((res) => {
        toast.success(res.data.message);
        onClose();
        setVerifySeccess((prevCheck) => (prevCheck = res.data.success));
        localStorage.setItem("otp", JSON.stringify(values.otp));
        resultHAndler();
      })
      .catch((ex) => {
        toast.error(ex?.response?.data?.message);

        setVerifySeccess(
          (prevCheck) => (prevCheck = ex?.response?.data?.success)
        );
      });
  };

  const validationSchema = Yup.object({
    otp: Yup.string().required("کد را وارد کنید"),
  });
  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
  });
  return (
    <Modal>
      <S.ModalContainer active={openModal}>
        {onClose ? (
          <S.ModalContainerBg
            $active={openModal}
            onClick={() => onClose()}
          ></S.ModalContainerBg>
        ) : (
          <S.ModalContainerBg $active={openModal}></S.ModalContainerBg>
        )}
        <S.ModalContainerContent $active={openModal}>
          {title && (
            <S.ModalContainerHeadTitle letterSpace={false} bold>
              {title}
            </S.ModalContainerHeadTitle>
          )}
          <div className="content">
            <S.TitleModal>
              <S.Title> تایید شماره تماس</S.Title>
              <S.BtnClose onClick={onClose}>
                <S.CloseSvg as={CloseIcon} />
              </S.BtnClose>
            </S.TitleModal>
            <form onSubmit={formik.handleSubmit}>
              <S.WrapperVerify>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px 0px",
                    width: "100%",
                  }}
                >
                  <S.Lable>
                    کد تایید
                    <S.Requierd>*</S.Requierd>
                  </S.Lable>
                  <S.InputField
                    type={"text"}
                    {...formik.getFieldProps("otp")}
                    name={"otp"}
                  />
                  <S.ErrorMessage>
                    {formik.errors["otp"] && formik.touched["otp"] && (
                      <div className="error">{formik.errors["otp"]}</div>
                    )}
                  </S.ErrorMessage>
                </div>

                <S.BtnConfirmation
                  className="btnnex"
                  type="submit"
                  disabled={!formik.isValid}
                >
                  تایید کد
                </S.BtnConfirmation>
              </S.WrapperVerify>
            </form>
          </div>
        </S.ModalContainerContent>
      </S.ModalContainer>
    </Modal>
  );
};

export default VerifyModal;
